import { poweredByHealthHub } from '@shared/assets';
import './styles.css';
import { sitecoreHomeBaseUrl } from '@shared/configs/configs/config';
import { SITE_CORE_URL } from '@shared/constants/paths';
import { MESSAGE_ACTIONS_KEYS } from '@shared/utils/bridge';

const CommonFooter = () => (
  <div className="block mb-5 common-footer">
    <div className="common-footer-link">
      <a
        data-navigation={MESSAGE_ACTIONS_KEYS.externalLink}
        href={`${sitecoreHomeBaseUrl()}${SITE_CORE_URL.privacyPolicy}`}
        id="lnkPrvivacy"
        rel="noopener noreferrer"
        target="_blank"
      >
        Privacy Policy
      </a>
      <span className="separator">|</span>
      <a
        data-navigation={MESSAGE_ACTIONS_KEYS.externalLink}
        href={`${sitecoreHomeBaseUrl()}${SITE_CORE_URL.termsOfUse}`}
        id="lnkTerms"
        rel="noopener noreferrer"
        target="_blank"
      >
        Terms of Use
      </a>
    </div>
    <div className="common-footer-logo">
      <img alt="" src={poweredByHealthHub} />
    </div>
  </div>
);

export default CommonFooter;
